import store from 'state'
import { DEFAULT_LOCAL_CURRENCY } from 'config/constants'

/**
 * Function to return localCurrency outwith a react component
 */
const getLocalCurrency = (): string => {
  const state = store.getState()
  const userLocalCurrency = state.user.localCurrency || DEFAULT_LOCAL_CURRENCY
  return userLocalCurrency
}

export default getLocalCurrency
